import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as resendOtpState from '../reducers/resend-otp.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region ResendOtp SUB STATE
export const getResendOtpState = createSelector(getAuthState, state => state[resendOtpState.resendOtpFeatureKey]);
//#endregion

//#region resend otp
export const getResendOtpIsLoading = createSelector(getResendOtpState, resendOtpState.getIsResendOtpLoading);
export const getResendOtpRequest = createSelector(getResendOtpState, resendOtpState.getResendOtpRequest);
export const getResendOtpSuccess = createSelector(getResendOtpState, resendOtpState.getResendOtpSuccess);
export const getResendOtpFailure = createSelector(getResendOtpState, resendOtpState.getResendOtpFailure);
//#endregion
